import { ComponentFactory, ComponentFactoryResolver, ComponentRef, ViewContainerRef } from "@angular/core";
import { PassKeyDeleteFailureComponent } from "./pass-key-delete-failure.component";


class PasskeyDeleteFailureForm implements com.ts.mobile.sdk.UIFormSession{
    clientContext: object;
    actionContext: object;
    formId: string;
    payload: object;

    submitHandler: any;
    submitBlock: (payload: object) => void;
    resolver: ComponentFactoryResolver;
    viewContainerRef: ViewContainerRef;
    passKeyDeleteSuccessComponentRef: ComponentRef<PassKeyDeleteFailureComponent>;

    constructor(formId: string, payload: object) {
        console.log('Inside PassKeyDeleteFailureComponent constructor');
        this.formId = formId;
        this.payload = payload;
    }

    startSession(clientContext: object | null, actionContext: com.ts.mobile.sdk.PolicyAction | null): void {
        console.log('PassKeyDeleteFailureComponent session started: ' + this.formId);
        this.clientContext = clientContext;
        this.actionContext = actionContext;
        this.resolver = (clientContext as any).resolver;
        this.viewContainerRef = (clientContext as any).viewContainerRef;
      }

      endSession(): void {
        console.log('PassKeyDeleteFailureComponent session ended: ' + this.formId);
      }

      promiseFormInput(): Promise<com.ts.mobile.sdk.FormInput> {
        console.log('PassKeyDeleteFailureComponent session Input: ' + this.formId);
        const self = this;
        self.viewContainerRef.clear();
        const factory: ComponentFactory<PassKeyDeleteFailureComponent> =
        self.resolver.resolveComponentFactory(PassKeyDeleteFailureComponent);

        self.passKeyDeleteSuccessComponentRef = self.viewContainerRef.createComponent(factory);
        self.passKeyDeleteSuccessComponentRef.instance.onCloseLinkSubmit = self.onCloseSubmit.bind(self);

        return new Promise((resolve, reject) => {
          self.submitBlock = (payload: object) => {
            try {
              resolve(com.ts.mobile.sdk.FormInput.createFormInputSubmissionRequest({}));
              console.log('PassKeyDeleteFailureComponent createFormInputSubmissionRequest SUCCESS payload: ', payload);
              self.submitBlock = null;
            } catch (e) {
              console.log('PassKeyDeleteFailureComponent createFormInputSubmissionRequest ERROR payload: ', payload);
              console.error(e);
            }
          };
        });
      }

      onContinue(payload: object): void {
        console.log('PassKeyDeleteFailureComponent SuccessTs onContinue for ' + this.formId + ' payload:', payload);
      }

      onError(payload: object): void {
        console.log('PassKeyDeleteFailureComponent SuccessTs onError for ' + this.formId + ' payload:', payload);
      }

      private onCloseSubmit() {
        this.submitBlock(null);
      }
}

export default PasskeyDeleteFailureForm;
